import { isDev, isProd, isStg } from 'utils/env';

export const getPlanningUrl = (runId) => {
	if (isDev()) {
		return `https://planning-dev.crew-dev.flix.tech/runs/${runId}`;
	} else if (isStg()) {
		return `https://planning-stg.crew-dev.flix.tech/runs/${runId}`;
	} else {
		return `https://planning.crew.flix.tech/runs/${runId}`;
	}
};

export const isProduction = () => isProd();

export const getOneOpsRideUrl = (rideId) => {
	if (isProd()) {
		return `https://app.oneops.flixbus.com/ops-portal/ride-control/ride/${rideId}`;
	}
	return null;
};
